module.exports = __webpack_public_path__ + "img/bionicmetrics-short.0216489e.png";